import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router";
import "./Contact.css";
import { FcBusinessman, FcBusinessContact } from "react-icons/fc";
import { FaLocationArrow } from "react-icons/fa";

const Contact = () => {
    let history=useHistory();
  const [user, setUser] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const { name, mobile, email, message } = user;

  const inputChangeHandler = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const submitHandler=async(e)=>{
      e.preventDefault();
      await axios.post(`http://localhost:3000/users`,user);
      history.push('/');
  }

  return (
    <section className="contact" id="contact">
      <div className="max-width">
        <h2 className="title">Contact me</h2>
        <div className="contact-content">
          <div className="column left">
            <div className="text">Get in Touch</div>
            <p>
              If you have questions, or if you want to contact, please contact
              me using my email id below and I look forward to meeting you to
              further discuss about any available opportunities.
            </p>
            <div className="icons">
              <div className="row">
                <FcBusinessman size="28px" className="i" />
                <div className="info">
                  <div className="head">Name</div>
                  <div className="sub-title">Rutvik Patel</div>
                </div>
              </div>
              <div className="row">
                <FaLocationArrow size="28px" className="i" />
                <div className="info">
                  <div className="head">Address</div>
                  <div className="sub-title">Canada</div>
                </div>
              </div>
              <div className="row">
                <FcBusinessContact size="28px" className="i" />
                <div className="info">
                  <div className="head">Email</div>
                  <div className="sub-title">orelic786@gmail.com</div>
                </div>
              </div>
            </div>
          </div>
          <div className="column right">
            <div className="text">Message me</div>
            <form
              action="#"
              onSubmit={e=>submitHandler(e)}
              name="contact"
              className="contact-form validate-form"
            >
              <div className="fields">
                <div className="field name">
                  <input
                    className="input"
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={name}
                    onChange={(e) => inputChangeHandler(e)}
                  ></input>
                </div>
                <div class="field email">
                  <input
                    name="email"
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => inputChangeHandler(e)}
                  ></input>
                </div>
              </div>
              <div class="field">
                <input
                  name="mobile"
                  type="tel"
                  placeholder="Mobile Number"
                  required
                  value={mobile}
                  onChange={(e) => inputChangeHandler(e)}
                ></input>
              </div>

              <div class="field textarea">
                <textarea
                  name="message"
                  cols="30"
                  rows="10"
                  placeholder="Message.."
                  required
                  value={message}
                  onChange={(e) => inputChangeHandler(e)}
                ></textarea>
              </div>
              <div class="button-area">
                <button type="submit" >Send message</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
